module.exports = __webpack_public_path__ + "hero-bg.svg?308e7d8619b345c72a2566b9730748c1";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hero-bg.svg
// module id = 98
// module chunks = 2